import {
  StrictOmit,
} from './typescript';

import {
  components,
} from '@/generated/qmulus/openapi.ts';
import {
  TComponentValue,
} from '@/types/openapi-type.ts';
import {
  colorPalette,
} from '@/utils/color.ts';

type TWorkplaceIdentifier = components['schemas']['WorkplaceIdentifier'];
type TPtDatabaseIdentifier = components['schemas']['PtDatabaseIdentifier'];
export type TWorkplaceAssetAssociation = (StrictOmit<components['schemas']['DataSourceAssociation'], 'dataSourceReference'> & {
  dataSourceReference: TWorkplaceIdentifier,
});
export type TWorkplaceFilter = {
  workplaceIdList?: number[],
  ptDbIdList?: number[],
};

export function getAssetAssociationListByWorkplaceFilter(
  dataSourceNodeList: components['schemas']['DataSource'][],
  filter: TWorkplaceFilter,
): TWorkplaceAssetAssociation[] {
  const associationList: TWorkplaceAssetAssociation[] = [];

  for (const dataSource of dataSourceNodeList) {
    for (const association of dataSource.assetAssociations) {
      if (!association.dataSourceReference) {
        continue;
      }
      const reference = association.dataSourceReference as TWorkplaceIdentifier | TPtDatabaseIdentifier;
      if (
        reference.type === 'WorkplaceIdentifier'
        // filter by ptDbIdList if any was given
        && (
          !filter.ptDbIdList
          || filter.ptDbIdList.length === 0
          || filter.ptDbIdList.includes(reference.ptDbId)
        )
        // filter by workplaceId if any was given
        && (
          !filter.workplaceIdList
          || filter.workplaceIdList.length === 0
          || filter.workplaceIdList.includes(reference.workplaceId)
        )
      ) {
        associationList.push(association as TWorkplaceAssetAssociation);
      }
    }
  }

  return associationList;
}

export const DataSourceColorMap: Record<TComponentValue<'DataSourceType'>, string> = {
  nitrex_plant_manager: colorPalette['orange-8'],
  pt9800: colorPalette['blue-8'],
  generic: colorPalette['slate-8'],
  job_feature: colorPalette['teal-8'],
  ml_model: colorPalette['purple-8'],
  production_statistics: colorPalette['green-8'],
  signal_builder: colorPalette['cyan-8'],
  model_builder: colorPalette['indigo-8'],
};

export const ALL_DATA_SOURCE_TYPES = Object.keys(DataSourceColorMap) as TComponentValue<'DataSourceType'>[];
